module.exports = __webpack_public_path__ + "static/media/user-img1.1dfd5962.svg";